var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":"/img/empty.png"}}),_c('span',[_vm._v("当前城市暂无领养信息~")])])}]

export { render, staticRenderFns }